import React, { Component } from 'react'
import { vuMainUnitLink } from '../../../helpers/links'
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { Search } from '@mui/icons-material'

class ChoiceLineSearchSelections extends Component {
  constructor(props) {
    super(props)
    this.state = {
      code: '',
      title: '',
      filteredSelections: []
    }
  }

  componentDidMount() {}

  renderSelectionPointsColumnName = () => {
    if (this.props.choiceLine.rule.structureRuleCode === '$CP') {
      return 'Credit Points'
    } else if (this.props.choiceLine.rule.structureRuleCode === '$NOC') {
      return 'Item(s)'
    }
  }

  handleFormOnSubmit = event => {
    event.preventDefault()
    let filteredSelections = []

    if (this.state.code || this.state.title || this.state.areaOfStudy) {
      filteredSelections = this.props.choiceLine.selections.filter(selection => {
        let codeIsNotNull = !!this.state.code
        let titleIsNotNull = !!this.state.title
        let areaOfStudy = !!this.state.areaOfStudy

        return (
          ((codeIsNotNull && selection.studyPackageCode.toLowerCase().includes(this.state.code.toLowerCase())) || !codeIsNotNull) &&
          ((titleIsNotNull && selection.studyPackageFullTitle.toLowerCase().includes(this.state.title.toLowerCase())) || !titleIsNotNull) &&
          ((areaOfStudy && selection.fieldOfEducationCode === this.state.areaOfStudy) || !areaOfStudy)
        )
      })
    }

    this.setState({
      filteredSelections: filteredSelections
    })
  }

  handleSearchFieldChange = (event, value) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleSelectChange = (event, index, value) => {
    this.setState({
      areaOfStudy: event.target.value
    })
  }

  renderMainUnitLink = (choiceLineSelection, title) => {
    if (this.props.choiceLine.rule.structureSelection) {
      return null;
    }

    return (
      <span>
        {vuMainUnitLink(choiceLineSelection.studyPackageCode, title)}
      </span>
    )
  }

  renderDivSelections = () => {
    return this.state.filteredSelections.map(choiceLineSelection => {
      let enableSelectionButton = this.props.availableSelections.length === 0
      if (!enableSelectionButton) {
        enableSelectionButton =
          this.props.availableSelections.some(selections => selections.rules.some(rule => rule.structureListId === choiceLineSelection.structureListId)) &&
          (this.props.selectedUnits.some(choiceLine => choiceLine.studyPackageNumber !== choiceLineSelection.studyPackageNumber) ||
            this.props.selectedUnits.some(
              choiceLine => choiceLine.studyPackageNumber === choiceLineSelection.studyPackageNumber && choiceLine.structureListId === choiceLineSelection.structureListId
            ))
      }

      if (enableSelectionButton && choiceLineSelection.studentStudyPackageAttempt >= 1) {
        enableSelectionButton = choiceLineSelection.canModify
      }

      let title = choiceLineSelection.canWithdraw
        ? 'You can’t change this selection because you are currently enrolled in this unit. Please withdraw from the unit and then try again, or contact your Course and Unit Advisor to discuss changing this selection.'
        : 'You can’t change this selection in MyVU. Please contact your Course and Unit Advisor to discuss changing this selection.'

      return (
        <div className={'choiceLineSelectionsRow'}>
          <FormGroup>
            <FormControlLabel
              label={(
                <div>
                  <label htmlFor={`${choiceLineSelection.structureId}_${choiceLineSelection.structureListId}_${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}>
                    {choiceLineSelection.studyPackageFullTitle}  | {choiceLineSelection.studyPackageCode} | {choiceLineSelection.credit} {this.renderSelectionPointsColumnName()}
                  </label>
                  {/* {this.renderMainUnitLink(choiceLineSelection, "Unit Information")} */}
                </div>
              )}
              control={
                <Checkbox
                  className="choiceLinesCheckbox"
                  disabled={!enableSelectionButton}
                  title={choiceLineSelection.studentStudyPackageAttempt >= 1 && !choiceLineSelection.canModify ? title : null}
                  labelStyle={{ zIndex: 3 }}
                  onChange={(event, isInputChecked) => this.props.handleChoiceLineSelection(choiceLineSelection, !isInputChecked, event)}
                  checked={this.props.selectedUnits && this.props.selectedUnits.some(choiceLine => choiceLine.studyPackageNumber === choiceLineSelection.studyPackageNumber)}
                />
              }
            />
          </FormGroup>
        </div>
      )
    })
  }

  renderCheckbox = (className, label, onChange, checked, title, disabled, labelStyle = {}) => {
    return (
      <FormGroup>
        <FormControlLabel
          label={label}
          control={
            <Checkbox
              className={className}
              //labelStyle={labelStyle}
              onChange={onChange}
              checked={checked}
              title={title}
              disabled={disabled} 
            />
          } 
        />
      </FormGroup>
    )
  }

  renderSelected = () => {
    let itemsToRender = []

    let unprocessedSelection = this.props.selectedUnits.filter(choiceLineSelection => {
      return choiceLineSelection.structureListId === this.props.choiceLine.rule.structureListId && !choiceLineSelection.onStudyPlan
    })

    this.props.choiceLine.selections.forEach(choiceLineSelection => {
      if (choiceLineSelection.onStudyPlan) {
        let enableSelectionButton = this.props.availableSelections.length === 0

        if (!enableSelectionButton) {
          enableSelectionButton =
            this.props.availableSelections.some(selections => selections.rules.some(rule => rule.structureListId === choiceLineSelection.structureListId)) &&
            (this.props.selectedUnits.some(choiceLine => choiceLine.studyPackageNumber !== choiceLineSelection.studyPackageNumber) ||
              this.props.selectedUnits.some(choiceLine => choiceLine.studyPackageNumber === choiceLineSelection.studyPackageNumber && choiceLine.structureListId === choiceLineSelection.structureListId))
        }

        if (enableSelectionButton && choiceLineSelection.studentStudyPackageAttempt >= 1) {
          enableSelectionButton = choiceLineSelection.canModify
        }

        let title = choiceLineSelection.canWithdraw
          ? 'You can’t change this selection because you are currently enrolled in this unit. Please withdraw from the unit and then try again, or contact your Course and Unit Advisor to discuss changing this selection.'
          : 'You can’t change this selection in MyVU. Please contact your Course and Unit Advisor to discuss changing this selection.'

        itemsToRender.push(
          React.createElement(
            'div',
            { className: 'choiceLineSelectionsRow' },
            this.renderCheckbox(
              'choiceLinesCheckbox',
              (
                <div>
                  <label htmlFor={`${choiceLineSelection.structureId}_${choiceLineSelection.structureListId}_${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}>
                    {choiceLineSelection.studyPackageFullTitle}  | {choiceLineSelection.studyPackageCode} | {choiceLineSelection.credit} {this.renderSelectionPointsColumnName()}
                  </label>
                  {/* {vuMainUnitLink(choiceLineSelection.studyPackageCode, "Unit Information")} */}
                </div>
              ),
                event => this.props.handleChoiceLineSelection(choiceLineSelection, true, event),
              true,
              choiceLineSelection.studentStudyPackageAttempt >= 1 && !choiceLineSelection.canModify ? title : null,
              !enableSelectionButton,
              { zIndex: 3 }
            )
          )
        )
      } else if (unprocessedSelection.some(unprocessedSelection => unprocessedSelection.studyPackageCode === choiceLineSelection.studyPackageCode)) {
        itemsToRender.push(
          React.createElement(
            'div',
            { classname: 'choiceLineSelectionsRow' },
            this.renderCheckbox(
              'choiceLinesCheckbox',
              (
                <div>
                  <label htmlFor={`${choiceLineSelection.structureId}_${choiceLineSelection.structureListId}_${choiceLineSelection.studyPackageCode}_${choiceLineSelection.studyPackageNumber}`}>
                    {choiceLineSelection.studyPackageFullTitle}  | {choiceLineSelection.studyPackageCode} | {choiceLineSelection.credit} {this.renderSelectionPointsColumnName()}
                  </label>
                  {/* {' '}{vuMainUnitLink(choiceLineSelection.studyPackageCode, "Unit Information")} */}
                </div>
              ),
              event => this.props.handleChoiceLineSelection(choiceLineSelection, true, event),
              true,
              null,
              false,
              { zIndex: 3 }
            )
          )
        )
      }
    })

    if (itemsToRender.length === 0) {
      return <div className={'choiceLineSelections'}>You have not selected any options yet</div>
    }

    return itemsToRender
  }

  render() {
    return (
      <div id={this.props.choiceLine.rule.structureListId} className={'modal-mb-10 selection-group-choiceline'}>
        <div className={'choiceLineSelectionsHeading'}>
          <h3>{this.props.choiceLine.rule.structureListName}</h3>
        </div>
        <div>
          {this.state.filteredSelections.length <= 0 && (
            <div className={'choiceLineNoSelections'}>
              <div className={'choiceLineSelectionsPL15'}>
                This list includes a large number of units. Please refer to your{' '}
                <a href={'https://www.vu.edu.au/current-students/your-course/enrolment/enrol-or-re-enrol/course-delivery-plans'} target={'_blank'}>
                  course delivery plan
                </a>{' '}
                and use the search function below to search for units available for selection.
              </div>
            </div>
          )}
          <div className={'choiceLineSelectionsPL15'}>
            <div className={'choiceLineSelectionsHeading'}>
              <h4>Search:</h4>
            </div>
            <div className={'choiceLineSelections choice-lines-search-bar'}>
              <form className={'choiceLineSelectionsRow search-group'} onSubmit={event => this.handleFormOnSubmit(event)}>
                <TextField 
                  name="code" 
                  label="Code" 
                  onChange={this.handleSearchFieldChange} 
                  value={this.state.code}
                  variant='standard'
                  fullWidth
                />
                <TextField 
                  name="title" 
                  label="Title"
                  onChange={this.handleSearchFieldChange} 
                  value={this.state.title}
                  variant='standard'
                  fullWidth
                />
                <FormControl variant='standard' fullWidth>
                  <InputLabel>Area of Study</InputLabel>
                  <Select 
                    name="areaOfStudy" 
                    onChange={this.handleSelectChange} 
                    value={this.state.areaOfStudy || ''} 
                  >
                    {this.props.choiceLine.fieldsOfEducation.map(foe => {
                      return <MenuItem key={foe.code} value={foe.code}>{foe.description}</MenuItem>
                    })}
                  </Select>
                </FormControl>
                
                <button type='submit' className="search-btn">
                  <Search className="btn-point-events" />
                </button>
              </form>
            </div>
          </div>
        </div>
        {this.state.filteredSelections.length > 0 && (
          <div className={'choiceLineSelectionsPL15'}>
            <div className={'choiceLineSelectionsHeading'}>
              <h4>Search Results:</h4>
            </div>
            <div className={'choiceLineSelections'}>{this.renderDivSelections()}</div>
          </div>
        )}
        <div className={'choiceLineSelectionsPL15'}>
          <div className={'choiceLineSelectionsHeading'}>
            <h4>Selected Options:</h4>
          </div>
          <div className={'choiceLineSelections'}>{this.renderSelected()}</div>
        </div>
      </div>
    )
  }
}

export default ChoiceLineSearchSelections
